export const apiUrls = {
  logOut: "/v2/logout",
  sendUserOTP: "/otp/v3/send",
  sendUserOTPV4: "/otp/v4/send",
  validateOTP: "/otp/v2/validate",
  RsaKey: "/v1/fetch/publicKey",
  basicUserDetails: "lcoUserService/internal/user/keycloak/get/details",
  fetchRoles: "lcoUserService/internal/user/keycloak/get/roles",
  getBooksByHub: "lcoUserService/config/all/books/mapping",
  createUser: "lcoUserService/internal/user/create",
  downloadResource: "lcoUserService/license/v1/document/download",
  licenseApproveReject: "lcoUserService/license/internal/approver/action",
  updatepObdStatus: "lcoUserService/internal/ne/validation/updatepObdStatus",
  getTicketsAnalytics: "tickets/getAnalytics",
  getDataLakeContents:
    "lcoUserService/internal/ne/validation/getDataLakeContents",
  getNeApprovalList:
    "lcoUserService/internal/ne/validation/getUncheckedPobdsForRMValidation",
  neApproveAction: "lcoUserService/internal/ne/validation/rmValidation",
  licenseList: "lcoUserService/license/search",
  bulkUpload: "lcoUserService/internal/ne/validation/uploadBulkCsv",
  getBulkData: "lcoUserService/internal/ne/validation/bulkNeUpdateSessions/all",
  getOneTimeBulkData: "lcoUserService/internal/oneTimeOrder/getJobInfo",
  getOneTimeFile: "lcoUserService/internal/oneTimeOrder/downloadFile",
  uploadOneTimeCsv:
    "lcoUserService/internal/oneTimeOrder/internal/uploadOneTimeOrder",
  fetchMasterData: "ticket/v1/get/allowed/ticketType",
  updateTicketDetails: "ticket/v1/updateTicket",
  getResolvers: "/cdtmttr/getStateBaseResolver",
  downloadAttachment: "tickets/download-file/v2",
  downloadBulkData:
    "lcoUserService/internal/ne/validation/recordsProcessedForUploadedFile",
  submitFeedback: "feedback/submitFeedback",
  getUserDetails: "lcoUser/lcoInternal/getUserDetails",
  getCompanyDetails: "feedback/getCompanyByGstin",
  userStates: "lcoUserService/user/fetch/details",
  prospectList: "lcoUserService/partnerEvaluation/internal/prospectList",
  compareProspect:
    "lcoUserService/partnerEvaluation/internal/computeProspectRanking",
  onboardProspect: "lcoUserService/partnerEvaluation/internal/prospectOnboard",
  getProspectTemplate:
    "lcoUserService/partnerEvaluation/internal/templateDetails",
  getCirclesByStateCode: "lcoUserService/partnerEvaluation/circleList",
  getTownList: "lcoUserService/partnerEvaluation/townList",
  getPopIdList: "lcoUserService/partnerEvaluation/popIdList",
  submitProspect: "lcoUserService/partnerEvaluation/internal/prospectDetails",
  getLicenseSummary: "lcoUserService/license/internal/get/summary",
  getPolyCities: "ftth/cities",
  getPolygonGeometry: "lco/getPolygonGeometry",
  filterUserInfo: "lcoUserService/user/filteredUserInfo",
  checkExisting:
    "lcoUserService/partnerEvaluation/internal/checkExistingUserOrNot",
  saveArea: "lco/polygon/edit",
  deleteArea: "lco/polygon/delete",
  addCity: "lco/polygon/createCities",
  updateOnBoardingState: "lcoUserService/user/state/proccess",
  getPaymentStatus: "lcoUserService/user/payment/txnDetails",
  uploadLicense: "lcoUserService/license/upload",
  activeInactiveData: "dashboard/base/level",
  earningsData: "dashboard/getEarnings",
  getCommissions: "dashboard/commissions/summary/calculated",
  getWinback: "dashboard/showMonthlyCustomerRechargeStats",
  submitTicket: "ticket/v1/createTicket",
  getIncidentTickets: "cdtmttr/getIncidentIdsByLcoId",
  getUserTickets: "tickets/get-user-tickets",
  getFeedbackForm: "feedback/getFeedBack/questions",
  getContactInfo: "lcoUserService/user/get/contactInfo",
  getSummaryDetails: "dashboard/getCommissions/details",
  initiateCall: "lcoUserService/ironman/initiate/call",
  getFeedbackOptions: "lcoUserService/ironman/feedback/options",
  saveFeedback: "lcoUserService/ironman/saveFeedback",
  activeInactiveCustomerBase: "dashboard/showInactiveCustomerData",
  getCartDetails: "lcoUserService/lcoOrder/get/cartDetails",
  getProductList: "lcoUserService/lcoOrder/get/all/items",
  getProductDetail: "lcoUserService/lcoOrder/get/item/info/avail/qty",
  submitOrderDetails: "lcoUserService/lcoOrder/submitOrderDetails",
  getCallingSummary: "lcoUserService/ironman/getCallingSummary",
  getAllOrders: "lcoUserService/lcoOrder/getAllOrder",
  getGstRevenueRange: "dashboard/getRevenueDateRange",
  getLicenseMandate: "lcoUserService/user/isBlocked",
  getPaymentTerms: "lcoUserService/lcoOrder/get/payment/term",
  getOrderInfo: "lcoUserService/lcoOrder/getOrderInfo",
  approvalsReminder: "lcoUserService/internal/reminder/get",
  partnersAllowedCall:
    "lcoUserService/ironman/get/partners/allowed/for/calling",
  pendingFeedback: "lcoUserService/ironman/get/partners/pending/feedback",
  mandaroeyCartDetails:
    "lcoUserService/lcoOrder/internal/getMandatoryCartOrderDetails",
  updateMandateOrder: "lcoUserService/lcoOrder/internal/updateOrderDetails",
  getOnHandQuantity: "lcoUserService/lcoOrder/getOnHandQuantity",
  allowedOrderUpdate: "lcoUserService/user/setIsOrderingAllowed",
  deleteCart: "lcoUserService/lcoOrder/internal/delete/cart",
  getAllItemsList: "lcoUserService/lcoOrder/get/items/",
  updateBdmRm: "lcoUserService/internal/user/updateBdmRm",
  getDetailsByPincode: "lcoUserService/internal/user/getDetailsByPincode",
  getCirclesByState: "lcoUserService/internal/user/getDistinctCircles",
  getStates: "lcoUserService/internal/user/getDistinctStates",
  getCityByState: "lcoUserService/internal/user/getDistinctCity",
  customerDetails: "customerSr/get/customerDetails",
  createCustomerSr: "customerSr/createCustomerSr",
  updateUserDetail: "lcoUserService/user/updateMobileAndEmail",
  financialService: "lcoUserService/finance/list/products",
  sendfinancialServiceLink: "lcoUserService/finance/send/invite/link",
  updateToolTip: "lcoUserService/user/updateToolTip",
  getNetworkItemSummary: "dashboard/getFatBoxUtilizationSummary",
  getNetworkItems: "dashboard/search/allocated/itemDetails",
  getDistinctRms: "lcoUserService/internal/user/getDistinctRms",
  getMembersListXFE: "api/v1/employee/list",
  withdrawProspect: "lcoUserService/partnerEvaluation/internal/deleteProspect",
  getCircleByGst: "lcoUserService/internal/user/getCircleByAllowed",
  getCircleList: "lcoUserService/partnerEvaluation/all/circleList",
  getCityList: "lcoUserService/partnerEvaluation/all/townList",
  getAllPopIdList: "lcoUserService/partnerEvaluation/all/popIdList",
  updateProspectConfigData:
    "lcoUserService/partnerEvaluation/internal/prospect/config/circleCityPopId",
  deletePartnerUser: "v5/deleteByEmailAndPartnership",
  bulkUploadCsv:
    "lcoUserService/partnerEvaluation/internal/prospect/uploadBulkCsv",
  getRoles: "/subUser/api/v1/employee/roles",
  aadhaarOtp: "/api/v1/aadhar/otp/send",
  aadharDigilocker: "/subUser/api/v2/add/employee",
  addMemberXfe: "/subUser/api/v1/add/employee",
  faceRecognition: "/subUser/api/v1/employee/fetch/recognition",
  updateUserProfile: "/user/v2/update/profile",
  getPolicyDocuments: "policy/document/v1/get/group",
  getPolicy: "policy/document/v1/fetch",
  saveInsurance: "/insurance/add",
  deleteUser: "/subUser/v1/delete/subUser",
  getGroupPolicyContract: "/insurance/api/v1/get/declaration",
  insuranceFilters: "/insurance/getFilters",
  insuranceApprovalList: "/approver/dynamic/search",
  getInsuranceSummary: "/approver/summary",
  insuranceAction: "/approver/api/v1/action",
  downloadInsurancePolicy: "/subUser/v1/document/download",
  bulkUploadInsuranceData: "/approver/get/bulk/inurance/uploaded/file/details",
  bulkUpdateInsurance: "/approver/updateCorporateInsuranceStatus",
  getTeamMemberList: "/subUser/api/v1/employee/list",
  ticketsList: "tickets/get-assigned-user-tickets",
  getInvoices: "v2/list/invoice/",
  fetchTurboIvp: "/v1/generate/ivp/token",
  fetchReceipts: "/v1/receipt/fetch",
  fetchInvoice: "v1/download/invoice",
  getInstallments: "installment/v1/list",
  getTicketingSearchFilters: "ticket/v1/searchFilters",
  getTickets: "ticket/dynamic/search",
  getCdtTicketSummary: "ticket/get/cdt/summary",
  getCdtTicketDetails: "ticket/get/cdt/details",
  getAdminTicketSummary: "ticket/get/summary?",
  downloadTicketAttachment: "ticket/v1/document/download",
  getGifts: "/promotional/list",
  claimGifts: "/promotional/send/prmotion/details",
  getComplianceTasks: "/promotional/list/v2",
  uploadFile: "/upload/file",
  submitComplianceTasks: "/promotional/submit/task",
  getInsuredUsers: "/vendor/search/employees",
  submitQuery: "/subUser/v1/query/raise",
  submitReply: "/vendor/reply/send",
  getContractDocuments: "/contract/v3/list/contract",
  downloadContractDocument: "/contract/v2/fetch/contract",
  insureSubUser: "/vendor/insure/subuser",
  downloadAddendum: "/addendum/v1/fetch",
  fnfInitiate: "api/v1/fnf/initiate",
  getCatalogProductListing: "/api/v1/scm/products",
  getScmMasterCategory: "/api/v1/scm/get/category",
  getAllScmCirles: "api/v1/scm/get/circles",
  getScmOrganisations: "/api/v1/scm/get/organization/circle",
  getScmLocations: "/api/v1/scm/get/location/organization",
  getScmCartDetails: "/api/v1/scm/get/cart",
  createScmOrder: "/api/v1/scm/create/pr",
  saveScmCart: "api/v1/scm/save/cart",
  getScmProductDetails: "/api/v1/scm/product/detail",
  getScmOrderStatus: "api/v1/scm/order/status",
  downloadAddendum: "/addendum/v1/fetch",
  scmBulkUpload: "/api/v1/scm/product/bulk/upload",
  downloadSoa: "lcoUserService/soa/list",
  createIllLead: "lcoUserService/user/create/illLead",
  getCustomerData: "lcoUserService/ironman/customer/offer",
  sendSms: "lcoUserService/ironman/send/sms",
  updateCatalogProduct: "/api/v1/scm/edit/product",
  partnershipTaskStatus: "/user/partnership/task/status"
};

export const BEFE_KEYS = {
  userMangement: "api/v1/lco/user",
  licenseList: "api/v1/lco/license/search",
  dataLakeConfig: "api/v1/lco/dataLakeConfig",
  bulkUploadConfig: "api/v1/lco/bulkUpload",
  getTicketsKey: "api/v1/lco/get/tickets",
  neApprovalConfig: "api/v1/lco/neApproval",
  partnerFeedback: "api/v1/lco/partnerFeedback",
  prospectConfig: "api/v1/lco/prospectEvaluationConfig",
  prospectTemplate: "api/v1/lco/prospectTemplate",
  viewDashboard: "api/v1/lco/dashboard",
  getPolyStates: "api/v1/lco/add/partnership",
  partnerTickets: "api/v2/lco/partnerTickets",
  getCommissionPlanDetails: "api/v1/lco/commisionPlanDetails",
  getMonthlyDeductions: "api/v1/lco/monthlyDeductions",
  getMttrDetails: "api/v1/lco/mttrDetails",
  getCdtDetails: "api/v1/lco/cdtDetails",
  statementAccount: "api/v1/lco/statementOfAccount",
  aircoinPageDetails: "api/v1/lco/aircoin",
  partnerDashboard: "api/v1/lco/partner/dashboard",
  manageTeamDetails: "api/v1/lco/partner/manage/team",
  inActiveBase: "api/v1/lco/inActiveBase",
  getOrders: "api/v1/lco/getOrders",
  notification: "api/v2/lco/notification",
  licenseUpload: "api/v1/lco/license/add",
  systemConfig: "api/v1/lco/masterConfig",
  airtelAmbassador: "api/v1/lco/airtelAmbassador",
  commonConfig: "api/v1/lco/commonConfig",
  myNetWork: "api/v2/lco/myNetWork",
  getMembersList: "api/v1/lco/manageMembersTable",
  insuranceList: "api/v1/lco/insurance/search",
  partnerDashboardDetails: "api/v1/lco/partner/dashboardDetails",
  createIllLead: "lcoUserService/user/create/illLead",
  getOrderDetail: "api/v1/lco/getOrderDetail",
  getInstallments: "api/v1/lco/getInstallments",
  getInvoices: "api/v1/lco/getInvoices",
  customerDownTime: "api/v1/lco/customerDownTime",
  vendorInsuredUsers: "api/v1/lco/vendor/manage/insurance",
  productCatalog: "api/v1/scm/product/catalog",
  scmOrders: "api/v1/scm/orders",
  scmProductDetail: "api/v1/scm/product/detail"
};
